const GENERIC_PLAYER_UNKNOWN = 'Joueur inconnu.';
const GENERIC_LOCATION_INVALID = 'Location invalide.';
const GENERIC_DATE_INVALID = 'Date invalide.';
const GENERIC_TIME_INVALID = 'Horaire invalide.';
const GENERIC_PLAYERS_INVALID = 'Le nombre de joueurs est invalide.';
const GENERIC_PRODUCT_NOT_FOUND = 'Produit introuvable.';
const GENERIC_AVAILABILITY_LACK = 'Manque de disponibilité.';
const GENERIC_DEPART_BLOCKED = 'Départ déjà bloqué.';

const errors = {
  sendgrid: {
    errors: {
      to: 'To email address not provided. Make sure you have a "to" property in your request',
      from: 'From email address not provided. Make sure you have a "from" property in your request',
      subject: 'Subject not provided. Make sure you have a "subject" property in your request',
      substitutions: 'Substitutions not provided. Make sure you have a "substitutions" property in your request',
      templateId: 'Template id not provided. Make sure you have a "templateId" property in your request',
    },
  },
  expo: {
    errors: {
      template: 'Numéro de template invalide',
      missing: 'Valeurs de remplacement du template introuvable : {{missing}}',
      token: 'Token manquant ou invalide. Assurez vous d\'avoir la propriété "token" dans votre requête.',
      title: 'Titre manquant. Assurez vous d\'avoir la propriété "title" dans votre requête.',
      body: 'Corps manquant. Assurez vous d\'avoir la propriété "body" dans votre requête.',
    },
  },
  yup: {
    string: {
      email: 'Adresse e‑mail invalide',
      required: 'Ce champ est requis',
      // eslint-disable-next-line no-template-curly-in-string
      min: 'Doit contenir au moins ${min} caractères',
      // eslint-disable-next-line no-template-curly-in-string
      max: 'Doit contenir au maximum ${max} caractères',
    },
    custom: {
      mismatched_emails: 'Les adresses e‑mail ne correspondent pas',
      mismatched_passwords: 'Les mots de passe ne correspondent pas',
      low_complexity: 'Le mot de passe doit contenir des lettres, des chiffres et un caractère spécial',
    },
  },
  errors: {
    network: 'Connexion réseau interrompue.',
    // À n'utiliser que quand le serveur A répondu (statut HTTP non-2xx) : le réseau
    // marche, c'est le traitement qui a échoué. Dire « réseau » dans ce cas envoie le
    // golfeur inspecter son wifi pour rien, et le support sur une fausse piste.
    // (`errors.server` est déjà pris : c'est un espace de noms, cf. plus bas.)
    server_error: 'Notre serveur n’a pas pu traiter la demande. Réessayez, et signalez-le au golf si cela se répète.',
    ws: 'Impossible de se connecter au golf.',
    internal: 'Une erreur est survenue.',
    something_wrong: 'Une erreur est survenue.',
    // Le golf n'a pas de contrat VADS Payline : il ne peut pas encaisser par
    // carte. C'est un état attendu pendant la bascule, pas un refus bancaire.
    // Levée par primagolf-master dès qu'un appelant demande un PSP indisponible.
    payment_unavailable: 'Le paiement par carte n\'est pas disponible pour ce golf.',
    not_found: 'Non trouvé.',
    expired_link: 'Le lien a expiré.',
    bad_request: 'Cette demande est invalide.',
    missing_params: 'Certaines informations sont manquantes pour traiter votre demande.',
    negative_price: 'Le montant calculé est invalide. Contactez le support.',
    no_source: 'Aucune source d\'affichage disponible.',
    access_denied: 'Accès refusé.',
    generic_fallback: 'Une erreur est survenue. Réessayez ou contactez le support.',
    server: {
      access_denied: 'Accès restreint.',
      invalid_token: 'Accès refusé.',
      invalid_credentials: 'Accès refusé.',
      invalid_key: 'Accès refusé.',
      no_key_provided: 'Accès refusé.',
    },
    user: {
      already_registered: 'Déjà enregistré.',
      not_found: 'Utilisateur inconnu.',
      create: 'Impossible de créer un compte.',
      logout: 'Déconnexion impossible.',
      password_confirm: 'Confirmation de mot de passe différente.',
    },
    booking: {
      already_canceled: 'Déjà annulé.',
      too_late: 'Impossible d\'annuler votre réservation.',
      slot_already_locks: 'Le créneau est en cours de réservation par un autre utilisateur.',
      duplicate: 'Vous avez déjà une réservation en cours pour ce créneau. Vérifiez vos réservations avant de réessayer.',
      online_card_too_close: 'Le paiement en ligne par carte n\'est plus possible à moins de 20 minutes du départ. '
        + 'Choisissez « Payer sur place » ou « Payer par compte client », ou rapprochez-vous du golf.',
      // Même règle, mais pour un golf qui n'ouvre AUCUN autre moyen de paiement : le
      // message ci-dessus renverrait vers des options inexistantes. On n'expose alors
      // ni choix ni bouton de paiement, seulement la marche à suivre. Levé par le
      // front (jamais par le serveur), donc lu depuis les traductions embarquées.
      no_payment_method_too_close:
        'Pour toute réservation inférieure à 20 minutes, nous vous invitons à vous rapprocher de l\'accueil.',
    },
    entry: {
      duplicate_in_progress:
        'Une inscription identique est déjà en cours d\'enregistrement. Ne renouvelez pas l\'opération : '
        + 'vérifiez vos inscriptions, et contactez votre golf en cas de doute sur le paiement.',
    },
    payment: {
      reversed: 'Le paiement a échoué et a été annulé. Aucun montant ne restera débité. Merci de réessayer.',
      compensation_failed: 'Un problème est survenu après votre paiement. Rapprochez-vous de votre golf : nous avons été notifiés et traiterons votre dossier.',
      rollback: 'Le paiement a échoué et a été annulé. Merci de réessayer.',
      bad_request: 'La demande de paiement est invalide. Réessayez ou contactez le support.',
      contract_missing: 'Le paiement n\'est pas disponible pour ce golf actuellement. Contactez le support.',
      // Levée par le verrou anti-doublon de master (DuplicatePaymentError). La clé
      // existait côté serveur sans traduction ici : l'utilisateur tombait sur le
      // message générique de repli, qui ne dit surtout pas le principal, à savoir
      // NE PAS refaire l'opération.
      duplicate_in_progress:
        'Une opération identique est déjà en cours d\'enregistrement. Ne renouvelez pas le paiement : '
        + 'vérifiez votre solde, et contactez votre golf en cas de doute.',
    },
    invalid: {
      credit_card: 'Carte de crédit inconnue.',
      golf: 'Golf inconnu.',
    },
    validation: {
      string: 'Format invalide.',
      tid: 'Reference du compte invalide. Doit commencer par G ou M et être suivi d\'une suite de chiffres',
      same_tid: 'L\'ancien TID est le même que le nouveau.',
      other_tid_exists: 'Le TID choisi existe déjà pour un autre compte',
      phone: 'Numéro de téléphone invalide.',
      email: 'Adresse email invalide.',
      date: 'Date invalide.',
      json: 'Format invalide.',
      number: 'Format invalide.',
      alpha: 'Format invalide. Ne sont autorisées que les lettres (a-zA-Z).',
      id: 'Identifiant invalide.',
      mimetype: 'Format de fichier invalide',
      docusign: {
        template_type: 'Le type de document sélectionné n\'est pas valide.',
      },
    },
    docusign: {
      make_template: 'Une erreur est survenue pendant la création du template Docusign',
      template_type: 'Type de template docusign invalide',
    },
    account: {
      not_found: 'Compte introuvable.',
      invalid_email: 'Adresse email invalide.',
    },
    currency: {
      not_accepted: 'Cette devise n\'est pas acceptée pour ce paiement.',
    },
    customer: {
      lightspeed_create: 'Impossible de créer votre profil client. Réessayez ou contactez le support.',
      lightspeed_update: 'Impossible de mettre à jour votre profil client. Réessayez ou contactez le support.',
      prima_ws: 'Une erreur est survenue lors de la synchronisation de votre profil. Réessayez plus tard.',
    },
    ffgApi: {
      auth: 'Connexion à la Fédération Française de Golf impossible pour le moment. Réessayez plus tard.',
    },
    golf: {
      not_found: 'Golf introuvable.',
    },
    hub: {
      network: 'Connexion à notre partenaire de réservation impossible pour le moment. Réessayez plus tard.',
      internal: 'Une erreur est survenue chez notre partenaire de réservation. Réessayez plus tard.',
    },
    membership: {
      not_found: 'Cotisation introuvable.',
    },
    push_campaign: {
      no_list: 'Aucune liste de diffusion associée à cette campagne.',
    },
    push_list: {
      empty: 'Cette liste de diffusion est vide.',
      not_found: 'Liste de diffusion introuvable.',
    },
    push_message: {
      creation_failed: 'Impossible de créer le message. Réessayez.',
    },
    sql: {
      bad_request: 'La requête est invalide. Contactez le support.',
    },
    subscription: {
      db: 'Une erreur est survenue sur votre abonnement. Contactez le support.',
      bad_request: 'La demande d\'abonnement est invalide.',
      ws: 'Une erreur est survenue lors de la synchronisation de votre abonnement. Réessayez plus tard.',
    },
  },
  PBX_DEFAULT: 'Une erreur est survenue : refus de paiement.',
  PBX00001: 'La connexion au centre d\'autorisation a échoué.',
  PBX00007: GENERIC_DATE_INVALID,
  PBX00008: 'Date de fin de validité dépassée.',
  PBX00020: 'Cryptogramme visuel non présent.',
  PBX00021: 'Carte non autorisée.',
  PBX00022: 'Plafond atteint.',
  PBX00141: 'Carte perdue.',
  PBX00143: 'Carte volée.',
  PBX00151: 'Provision insuffisante ou crédit dépassé.',
  PBX00154: 'Date de validité de la carte dépassée.',

  // Course schedule
  R15x1:
    'Un problème de connexion à la base de données 2 est survenu. Veuillez réessayer plus tard ou contacter le support.',
  R15x2:
    'Un problème de connexion à la base de données 2 (Ticket) est survenu. Veuillez réessayer plus tard ou contacter le support.',
  R100: 'Le départ n\'est plus disponible.',
  R101: 'Vous avez déjà une réservation pour cette journée.',
  R102: 'Les visiteurs ne sont pas autorisés.',
  R103: 'Votre cotisation n\'est pas valide.',
  R104: 'Le quota de réservation est dépassé.',
  R105: 'Votre cotisation n\'est pas valide pour ce jour.',
  R106: 'Votre cotisation n\'est pas valide pour ce jour férié.',
  R107: 'Cotisation en cours de validité.',
  R114: 'Parcours inconnu.',
  R115: 'Parcours fermé.',
  R117: GENERIC_PLAYER_UNKNOWN,
  // Accessory schedule
  R130: 'Cotisation invalide.',
  R131: 'Aucune location disponible.',
  R136: GENERIC_LOCATION_INVALID,
  R137: GENERIC_LOCATION_INVALID,
  // Book teetime
  R151: GENERIC_DATE_INVALID,
  R154: GENERIC_TIME_INVALID,
  R156: GENERIC_PLAYERS_INVALID,
  R160: 'Départ bloqué.',
  R161: GENERIC_DEPART_BLOCKED,
  R162: GENERIC_AVAILABILITY_LACK,
  R163: 'Retour indisponible. Veuillez réserver sur un 9 trous pour ce créneau.',
  // Lock accessory
  R181: GENERIC_DATE_INVALID,
  R184: GENERIC_TIME_INVALID,
  R186: 'Quantité invalide.',
  // Book accessory
  R201: GENERIC_DATE_INVALID,
  R204: GENERIC_TIME_INVALID,
  R206: 'Quantité invalide.',
  R209: GENERIC_DATE_INVALID,
  // Cancel accessory
  R221: GENERIC_DATE_INVALID,
  R224: GENERIC_TIME_INVALID,
  R226: 'Code de blocage invalide.',
  R227: 'Location inconnue.',
  R228: 'Location inconnue.',
  // Membership info
  R240: GENERIC_PLAYER_UNKNOWN,
  R241: GENERIC_PLAYER_UNKNOWN,
  R242: GENERIC_PLAYER_UNKNOWN,
  // Membership payment schedule
  R250: 'Plan de prélèvement invalide.',
  R251: GENERIC_PLAYER_UNKNOWN,
  R252: GENERIC_PLAYER_UNKNOWN,
  R253: 'Données invalides.',
  R254: 'Déjà existant.',
  // Membership payment request
  R260: GENERIC_PLAYER_UNKNOWN,
  R261: GENERIC_PLAYER_UNKNOWN,
  R263: 'Données invalides.',
  R264: 'Plan de prélèvement invalide.',
  // Lock teetime
  R271: GENERIC_DATE_INVALID,
  R275: GENERIC_PLAYERS_INVALID,
  R276: 'Parcours invalide.',
  R277: GENERIC_AVAILABILITY_LACK,
  R278: GENERIC_DEPART_BLOCKED,
  // Cancel booking
  R290: 'Délai d\'annulation dépassé.',
  R291: 'Réservation non trouvée.',

  R300: 'Impossible de trouver l’activité demandée.',
  R301: 'Une erreur de traitement est survenue.',
  R302: 'Le tarif du produit est négatif.',
  R303: GENERIC_PRODUCT_NOT_FOUND,
  R304: 'Aucune activité indiquée.',
  R305: 'La réservation sélectionnée ne peut pas être effectuée en ligne.',
  R306: 'Cette réservation a déjà été encaissée.',
  R307: 'L’annulation est interdite pour cette activité.',
  R308: 'La date saisie est invalide.',
  R309: 'La ressource demandée est introuvable.',
  R310: 'La date de début saisie est invalide.',
  'R310-1': 'La date de fin saisie est invalide.',
  R311: GENERIC_PLAYERS_INVALID,
  'R311-1': GENERIC_PLAYERS_INVALID,
  R312: 'Le nom du réservataire est invalide.',
  R313: 'Problème avec l’identifiant du compte client.',
  R314: 'Le joueur invité est introuvable.',
  R315: 'Le joueur membre est introuvable.',
  R316: 'Le créneau de réservation est déjà pris.',
  R317: 'Le créneau de réservation est introuvable.',

  R319: 'Type de règlement non reconnu ou invalide.',
  R320: 'Facturation au créneau : il ne peut y avoir qu’une seule personne payante pour ce créneau.',

  R409: 'Plus de place disponible pour cette compétition.',
  R410: 'Plus de place disponible pour ce créneau.',
  R411: 'Plus de place disponible pour cet évènement.',
  R412: 'Déjà enregistré à cette compétition.',
  R413: 'Déjà enregistré à cet événement.',
  R414: 'Partenaire déjà enregistré à cette compétition.',
  R415: 'Partenaire déjà enregistré à cet événement.',
  R416: 'Événement inexistant.',

  R418: 'L’identifiant du compte est manquant.',
  // Détails compétition / événement
  R454: 'Pour vous inscrire, merci de vous abonner.',
  R455: 'Pour vous inscrire, merci de vous rapprocher du golf.',
  R456: 'Membre introuvable.',
  R457: 'Pour vous inscrire, merci de régler votre cotisation.',
  R458: 'Vous êtes déjà inscrit à un événement à cette date.',
};

// On complète avec toutes les erreurs R### manquantes jusqu'à R999, avec le message par défaut si non défini.
for (let i = 100; i <= 999; i += 1) {
  const key = `R${i}`;
  if (!errors[key]) {
    errors[key] = `Une erreur est survenue (${i}).`;
  }
}

export default errors;
